export default {
    methods: {
        getLotCategory(providerName) {
            return providerName === 'PSF'
                ? "Hotel & Parking Package"
                : "Airport Parking Only";
        }
    }
}
